// extracted by mini-css-extract-plugin
export default {"primary":"styles_primary__qDWAA"};